export default __webpack_public_path__ + "static/media/our-process-teb-img-03.2c7a56da.jpg";